// philippinesV2Language.ts
// ─── Astria Philippines v2 — EN/PH language ──────────────────────────────────
// Follows the user's preferred language (utils/appLanguage.ts): PH when
// that is the preference, English otherwise. No per-screen toggle.
import { getAppLanguage, pickLanguage, useAppLanguage } from "../../../utils/appLanguage";

export type PhilippinesV2Lang = "en" | "ph";

const SUPPORTED: readonly PhilippinesV2Lang[] = ["en", "ph"];
const ALIASES: Partial<Record<string, PhilippinesV2Lang>> = { fil: "ph" };

const resolve = (appLanguage: string): PhilippinesV2Lang =>
  pickLanguage(appLanguage, SUPPORTED, ALIASES);

export const getPhilippinesV2Lang = (): PhilippinesV2Lang => resolve(getAppLanguage());

export function usePhilippinesV2Language(): PhilippinesV2Lang {
  return resolve(useAppLanguage());
}
